module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_8.22ac6c07.png";